
//首页时间转化
const dateTime = (e) => {
	let old = new Date(e);
	let now = new Date();
	//获取old具体时间
	let d = old.getTime();
	let h = old.getHours();
	let m = old.getMinutes();
	let Y = old.getFullYear();
	let M = old.getMonth() + 1;
	let D = old.getDate();
	//获取now具体时间
	let nd = now.getTime();
	let nh = now.getHours();
	let n = now.getMinutes();
	let nY = now.getFullYear();
	let nM = now.getMonth() + 1;
	let nD = now.getDate();

	//当天的时间
	if (D === nD && M === nM && Y === nY) {
		if (h < 10) {
			h = '0' + h;
		}
		if (m < 10) {
			m = '0' + m;
		}
		return h + ':' + m;
	}
	//昨天时间
	if (D + 1 === nD && M === nM && Y === nY) {
		if (h < 10) {
			h = '0' + h;
		}
		if (m < 10) {
			m = '0' + m;
		}
		return '昨天 ' + h + ':' + m;
	} else {
		//大于两天
		return Y + '/' + M + '/' + D;
	}

}
//聊天时，发送时间处理
const dateTime1 = (e) => {
	let old = new Date(e);
	let now = new Date();

	// 获取old具体时间
	let h = old.getHours();
	let m = old.getMinutes();
	let Y = old.getFullYear();
	let M = old.getMonth() + 1;
	let D = old.getDate();
	let W = old.getDay(); // 获取星期

	// 获取now具体时间
	let nY = now.getFullYear();
	let nM = now.getMonth() + 1;
	let nD = now.getDate();

	// 补零函数
	const padZero = (num) => num < 10 ? '0' + num : num;

	// 格式化时间
	const timeStr = `${padZero(h)}:${padZero(m)}`;

	// 获取星期显示
	const weekDays = ['日', '一', '二', '三', '四', '五', '六'];

	// 计算是否是同一周
	const getWeekNumber = (d) => {
		d = new Date(d);
		d.setHours(0, 0, 0, 0);
		d.setDate(d.getDate() + 4 - (d.getDay() || 7));
		const yearStart = new Date(d.getFullYear(), 0, 1);
		return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
	};

	// 当天
	if (D === nD && M === nM && Y === nY) {
		return timeStr;
	}

	// 昨天
	if (D + 1 === nD && M === nM && Y === nY) {
		return `昨天 ${timeStr}`;
	}

	// 本周内
	if (Y === nY && getWeekNumber(old) === getWeekNumber(now)) {
		return `星期${weekDays[W]} ${timeStr}`;
	}

	// 本年内
	if (Y === nY) {
		return `${M}月${D}日 ${timeStr}`;
	}

	// 往年
	return `${Y}年${M}月${D}日 ${timeStr}`;
}
// 间隔时间差
const spaceTime = (old, now) => {
	if (!old || !now) return true;
	// 确保是时间戳格式
  const oldTime = new Date(old).getTime();
	const nowTime = new Date(now).getTime();
	console.log('oldTime', oldTime, nowTime)
  return Math.abs(nowTime - oldTime) > 1000 * 60 * 5;
}



// 获取当前时间
const getDate = () => {
	var date = new Date();
	// 年
	let y = date.getFullYear()
	// 月
	let m = date.getMonth() + 1
	m = m < 10 ? ('0' + m) : m
	// 日
	let d = date.getDate()
	d = d < 10 ? ('0' + d) : d
	// 时
	let h = date.getHours()
	h = h < 10 ? ('0' + h) : h
	// 分
	let M = date.getMinutes()
	M = M < 10 ? ('0' + M) : M
	// 秒
	let s = date.getSeconds()
	return y + '-' + m + '-' + d + ' ' + h + ':' + M + ':' + s;
}


const computingTime = (startPeriod, endPeriod) => {
	let start = ""
	// 获取当前日期的年、月、日
	const currentDate = new Date();
	const year = currentDate.getFullYear();
	const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1并补零
	const day = String(currentDate.getDate()).padStart(2, "0");
	// 将当前日期和后端返回的时间字符串拼接成完整的日期时间字符串
	const startPeriodTimeStr = `${year}-${month}-${day}T${startPeriod}`;
	const endPeriodPeriodTimeStr = `${year}-${month}-${day}T${endPeriod}`;
	const startPeriodTime = new Date(startPeriodTimeStr);
	const endPeriodTime = new Date(endPeriodPeriodTimeStr);
	// 活动未开始
	if (currentDate < startPeriodTime) {
		start = "距离活动开始"
		const timeDifference = startPeriodTime - currentDate;
		const hours = Math.floor(timeDifference / 3600000);
		const minutes = Math.floor((timeDifference % 3600000) / 60000);
		const seconds = Math.floor((timeDifference % 60000) / 1000);
		return {
			hours,
			minutes,
			seconds,
			start
		};
	} else if (
		currentDate >= startPeriodTime &&
		currentDate <= endPeriodTime
	) {
		start = "距离活动结束"
		const timeDifference = endPeriodTime - currentDate;
		const hours = Math.floor(timeDifference / 3600000);
		const minutes = Math.floor((timeDifference % 3600000) / 60000);
		const seconds = Math.floor((timeDifference % 60000) / 1000);
		return {
			hours,
			minutes,
			seconds,
			start
		};
	}
}
// 添加 formatDate 别名以兼容现有代码
const formatDate = dateTime

export {
	dateTime,
	dateTime1,
	spaceTime,
	getDate,
	computingTime,
	formatDate
}